<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.24267 3.64676C2.31493 3.38537 2.51856 3.18773 2.78789 3.1176C3.05722 3.04747 3.33311 3.1176 3.53018 3.30886L4.40385 4.1568L4.63376 3.95916C7.74088 
          1.31334 11.6297 0 15.5054 0C19.7423 0 23.9727 1.56836 27.1784 4.67958C30.2855 7.69517 32 11.7181 32 15.996C32 20.2803 30.2855 24.2969 27.1784 27.3188C20.7474 
          33.5604 10.2831 33.5604 3.85206 27.3188C3.63528 27.1084 3.51704 26.8343 3.51704 26.541C3.51704 26.2477 3.63528 25.9736 3.85206 25.7632C4.29218 25.3361 5.01476 
          25.3361 5.45488 25.7632C8.13501 28.3644 11.7085 29.7989 15.5185 29.7989C19.3219 29.7989 22.8954 28.3644 25.5821 25.7632C31.1329 20.376 31.1329 11.6161 25.5821 
          6.23519C23.0268 3.76152 19.6438 2.33342 16.0375 2.20591C12.4508 2.0784 8.98898 3.24511 6.276 5.49564L6.00667 5.71878L6.86064 6.54759C7.0577 6.73885 7.12996 
          7.00662 7.0577 7.26802C6.98545 7.52941 6.78181 7.72705 6.51248 7.79718L1.96677 8.98302C1.69744 9.05314 1.42155 8.98302 1.22448 8.79175C1.02741 8.60049 0.955154 
          8.33272 1.02741 8.07133L2.24267 3.64676Z"
        fill="white"
      />
      <path
        d="M12.0996 22.0807C12.2595 22.2016 12.4195 22.262 12.5794 22.262C12.7394 22.262 12.8993 22.2016 13.0593 22.0807L20.9502 16.9451C21.2168 16.7639 21.43 16.4014 
          21.43 15.9784C21.43 15.5555 21.2701 15.193 20.9502 15.0118L13.0593 9.87618C12.7394 9.69492 12.3662 9.69492 12.0463 9.87618C11.7797 10.0574 11.5664 10.4199 11.5664 
          10.8429V21.114C11.5664 21.537 11.7797 21.8995 12.0996 22.0807Z"
        fill="white"
      />
    </svg>
</template>
